module.exports = __webpack_public_path__ + "static/media/cosmowhite.06a6bed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cosmowhite.png
// module id = 234
// module chunks = 0